import {createContext} from 'react';

const CaptchaContext = createContext();
CaptchaContext.displayName = 'Captcha';

export default CaptchaContext;
